import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { CustomButton, WhiteCard } from 'src/components';

import './reviewItem.scss';

export const ReviewItem = (props) => {
  const { item } = props;

  const { t } = useTranslation();

  const { created_at = '', message = '', name = '' } = item;

  const [isFullDetails, setIsFullDetails] = useState(false);

  const isShowButton = message.length > 70;

  const onClickShow = useCallback(() => {
    setIsFullDetails((prev) => !prev);
  }, []);

  const contentStyles = classNames('review-item__content', {
    'review-item__content--flex': isFullDetails,
  });

  const commentStyles = classNames('review-item__review', {
    'review-item__review--absolute': isShowButton && !isFullDetails,
    'review-item__review--default': isShowButton && isFullDetails,
  });

  const buttonStyles = classNames('review-item__button', {
    'review-item__button--active': isFullDetails,
  });

  return (
    <div className="review-item">
      <WhiteCard>
        <div className="review-item__title">
          <h5>
            <img src="" alt="" />
            {name}
          </h5>
          <div className="review-item__date">{created_at}</div>
        </div>
        <div className={contentStyles}>
          <div className="review-item__content__comment">
            <span className={commentStyles}>{message}</span>
          </div>
          {isShowButton && (
            <div className={buttonStyles}>
              <CustomButton variant="outlined" title={t('title:further')} onClick={onClickShow} />
            </div>
          )}
        </div>
      </WhiteCard>
    </div>
  );
};
